import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Box, IconButton, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useMobile } from 'shared/domains/common-ui';
import { usePromptLibrary } from '../../PromptLibraryProvider';
import { Filters } from '../Filters';
import { Container } from './styled';
export function Header() {
    const { closeDialog, currentPromptID, setCurrentPromptID, currentPrompt } = usePromptLibrary();
    const isMobile = useMobile();
    const title = (currentPrompt === null || currentPrompt === void 0 ? void 0 : currentPrompt.name) ||
        t({
            message: 'Prompt Library',
            comment: 'Select prompt dialog - Prompt library title',
        });
    const subtitle = currentPromptID
        ? t({
            message: 'Preview prompt',
            comment: 'Select prompt dialog - Preview prompt subtitle',
        })
        : t({
            message: 'Select a prompt from your library',
            comment: 'Select prompt dialog - Prompt library subtitle',
        });
    return (<Fragment>
      <Container>
        <Box alignItems="center" gap="md">
          {currentPromptID && (<IconButton onClick={() => setCurrentPromptID(undefined)} appearance="secondary">
              <Falcon icon="arrow-left"/>
            </IconButton>)}
          <Box flexDirection="column">
            <Typography $appearance="300" $fontSize="large" $fontWeight="semibold">
              {title}
            </Typography>
            {!isMobile && (<Typography $appearance="200" $fontSize="small" $lineHeight="neutralized">
                {subtitle}
              </Typography>)}
          </Box>
        </Box>
        <IconButton $round appearance="ghost" onClick={closeDialog}>
          <Falcon icon="xmark"/>
        </IconButton>
      </Container>
      {isMobile && <Filters />}
    </Fragment>);
}
